import { Link } from "react-router-dom";
import { siteStats } from "@/mocks/home";

const highlights = [
  {
    icon: "ri-layout-masonry-line",
    title: "结构化的档案",
    text: "每位女优的生日、出道年份、所属事务所与代表作品均以固定字段整理，便于横向对照。",
  },
  {
    icon: "ri-filter-3-line",
    title: "可组合的筛选",
    text: "年龄、出道年份、活跃状态与事务所可以任意组合，列表结果实时刷新。",
  },
  {
    icon: "ri-shield-check-line",
    title: "纯粹的索引",
    text: "本站不提供视频播放、下载或交易入口，仅做资料与资讯的整理与导航。",
  },
];

export default function HomeIntro() {
  return (
    <section className="mt-14 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <div className="grid gap-0 lg:grid-cols-[1.15fr_1fr]">
        <div className="p-6 md:p-10">
          <p className="flex items-center gap-2 font-label text-[11px] tracking-[0.18em] text-primary-600">
            <span className="h-px w-6 bg-accent-500"></span>
            ABOUT THE ARCHIVE
          </p>
          <h2 className="mt-2 font-heading text-2xl font-black md:text-[28px]">关于这座资料库</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700">
            日本女优是一份面向影视爱好者与研究者的资料索引。我们把分散在作品表、访谈与新闻里的信息重新整理成可检索的结构：从一位演员的出道年份与所属事务所，到她的代表作品与最近动向，都可以在同一个页面里串起来。
          </p>
          <ul className="mt-6 space-y-4">
            {highlights.map((item) => (
              <li key={item.title} className="flex gap-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-700">
                  <i className={`${item.icon} text-base`} aria-hidden="true"></i>
                </span>
                <div>
                  <h3 className="font-label text-sm font-medium text-foreground-900">{item.title}</h3>
                  <p className="mt-0.5 text-sm leading-relaxed text-foreground-600">{item.text}</p>
                </div>
              </li>
            ))}
          </ul>
          <div className="mt-7 flex flex-wrap items-center gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              了解站点定位与声明
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
            <Link
              to="/category"
              className="inline-flex items-center gap-1.5 rounded-md border border-background-300 px-4 py-2 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              浏览全部女优
            </Link>
          </div>
        </div>

        <div className="relative min-h-[280px] overflow-hidden bg-background-200">
          <img
            src="https://readdy.ai/api/search-image?query=Quiet%20editorial%20photograph%20of%20a%20Japanese%20archive%20reading%20room%20with%20wooden%20shelves%20of%20film%20journals%2C%20warm%20afternoon%20light%20through%20paper%20screens%2C%20soft%20amber%20and%20crimson%20tones%2C%20minimal%20elegant%20interior%2C%20no%20people%2C%20high%20detail%20film%20texture&width=900&height=800&seq=archive-intro-01&orientation=squarish"
            alt="日本女优资料库的档案阅读室场景"
            title="日本女优资料库 档案与作品索引"
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-x-4 bottom-4 rounded-lg bg-background-50/95 p-4">
            <div className="grid grid-cols-3 gap-2 text-center">
              {siteStats.map((stat) => (
                <div key={stat.label}>
                  <p className="font-heading text-xl font-black text-primary-700">
                    {stat.value}
                    <span className="ml-0.5 font-label text-[11px] font-normal text-foreground-500">
                      {stat.unit}
                    </span>
                  </p>
                  <p className="mt-0.5 font-label text-[10px] text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}